var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#D2E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 27.8001C31.3693 27.8001 34.1004 25.069 34.1004 21.7001C34.1004 18.3312 31.3693 15.6001 28.0004 15.6001C24.6315 15.6001 21.9004 18.3312 21.9004 21.7001C21.9004 25.069 24.6315 27.8001 28.0004 27.8001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3002 34.6C35.8002 29.1 28.0002 29.5 28.0002 29.5C28.0002 29.5 20.2002 29 16.7002 34.6C12.9002 40.7 21.4002 40.8 28.0002 40.8C34.6002 40.8 43.1002 40.7 39.3002 34.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6116be1324be46ababec3c0330f0a471.svg";
export { ForwardRef as ReactComponent };